<template>
  <div>
    <div id="app">


        <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
          min-width="360px"
        >
          <div class="primary">
            <img src="@/assets/Logo.png"
            height="50em"
            class="mt-2 ml-2"/>
            <v-tabs
              v-model="tab"
              show-arrows
              background-color="primary accent-4"
              icons-and-text
              m4u_tertiary
              grow
            >
              <v-tabs-slider color=" primary darken-4 m4u_text--text large"></v-tabs-slider>
              <v-tab v-for="tab in tabs" :key="tab.tabname">
                <v-icon large class="m4u_text--text">{{ tab.icon }}</v-icon>
                <div class="caption py-1 m4u_text--text">{{ tab.tabname }}</div>
              </v-tab>
              <v-tab-item>
                <v-card class="px-4 m4u_tertiary">
                  <v-card-text>
                    <h1 v-if="message">{{ message }}</h1>

                    <v-form ref="loginForm" v-model="valid" lazy-validation class="m4u_tertiary">
                      <v-row>
                        <v-col cols="12">
                          <v-text-field
                            v-model="email"
                            :rules="loginEmailRules"
                            label="E-mail"
                            required
                            color="m4u_text"
                            tabindex="1"
                          ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                          <v-text-field
                            v-model="password"
                            :append-icon="show1 ? 'eye' : 'eye-off'"
                            :rules="[rules.required]"
                            :type="show1 ? 'text' : 'password'"
                            name="input-10-1"
                            label="Password"
                            color="m4u_text"
                            @click:append="show1 = !show1"
                            tabindex="2"
                          ></v-text-field>
                          <router-link to="forgot" class="m4u_text--text">Forgot Password</router-link>
                        </v-col>
                        <v-col class="d-flex" cols="12" sm="6" xsm="12">
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col
                          class="d-flex"
                          cols="12"
                          sm="3"
                          xsm="12"
                          align-end
                        >
                          <v-btn
                            large
                            block
                            :disabled="!valid"
                            color="primary"
                            class="m4u_text--text"
                            @click="validate"
                            tabindex="3"
                          >
                            Login
                          </v-btn>
                        </v-col>
                      </v-row>


                    </v-form>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item>
                <v-card class="px-4">
                  <v-card-text>
                    <h2 class="m4u_text--text">Memories For Us is still in beta and only available through invitation at this time. If you are interested in being an early member, 
                      please email us at <a href = "mailto: info@memoriesforus.com">info@memoriesforus.com</a>
                    </h2>

                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-dialog>

    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";

export default {
  computed: {
    passwordMatch() {
      return () => this.password === this.verify || "Password must match";
    },
    user() {
      return this.$store.state.user;
    },
  },

  mounted() {

    this.message = "";
    this.regmessage = "";
    this.$nextTick(function () {
      if (this.tabset === "Login") {
        this.tab = 0;
      }
      if (this.tabset === "Register") {
        this.tab = 1;
      }
    });
  },
  methods: {

    validate() {
      if (this.$refs.loginForm.validate()) {
        this.tab = 0;
        this.login(this.email, this.password);
      }
    },
    validateReg() {
      if (this.$refs.registerForm.validate()) {
        this.tab = 1;
        this.errMsg = "";
        this.registration(
          this.email,
          this.password,
          this.firstName,
          this.lastName,
          this.displayName
        );
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    async login(userEmail, userPassword) {
      this.message = "";
//      console.log('the domain is: ', window.location.hostname)
      await EventService.login(userEmail, userPassword)
        .then((userInfo) => {
           if (userInfo === false || userInfo === undefined) {
            this.message = "Invalid login";
            this.tab = 0;
            this.loggedin = false;
            return;
          } else {
            const loginInfo = {'user': userInfo, 'token': userInfo.token, 'reauthToken': userInfo.reauthToken }
            this.$store.dispatch("login", loginInfo.user, loginInfo.token, loginInfo.reauthToken);
            this.$set(this, "userInfo", userInfo.user);
            this.loggedin = true;
          }
        })
        .then(async () => {
          let retProfileSas = await EventService.getSASKey(
            this.$store.state.user.UserMediaLoc
          );
//          console.log("es getSASKey for profile in login is:", retProfileSas);
          this.ps = retProfileSas;
        })
        .then(() => {
//          console.log("incoming profileSas is: ", this.ps);
          this.$store.dispatch("setProfileSas", this.ps);

          // console.log(
          //   "store value of profileSas is:",
          //   this.$store.state.profileSas
          // );
          this.profileSas = this.$store.state.profileSas
        })

        .then(() => {
          if (this.loggedin === true) {

          if(this.userInfo.TCAcceptDate === null || this.userInfo.TCAcceptDate < this.policyDate ) {
//              console.log('should push to policies')
               this.$router.push({ name: 'policies'})
            } else {
            this.$router.push("home"); }
          }
        });
    },

    async registration() {
      EventService.registration(
        this.firstName,
        this.lastName,
        this.displayName,
        this.email,
        this.password
      ).then((dupcheck) => {
        if (dupcheck === "duplicate") {
          this.regmessage = "This email address is already registered";
          return;
        } else {
          this.$router.push({ name: "RegistrationConfirmation" });
        }
      });
    },
  },
  props: ["tabset"],
  data: () => ({
    policyDate: '2021-11-17 00:00:00.000',
    userInfo: [],
    dialog: true,
    tab: 0,
    tabs: [
      { tabname: "Login", icon: "mdi-account-outline" },
      { tabname: "Register", icon: "mdi-account-outline" },
    ],
    valid: true,
    tcDialog: false,

    firstName: "",
    lastName: "",
    displayName: "",
    email: "",
    password: "",
    charterCode: "",
    verify: "",
    message: "",
    regmessage: "",
    errMsg: "",
    ps: "",
    profileSas: "",
    loginPassword: "",
    loginEmail: "",
    loginEmailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],
    emailRules: [
      (v) => !!v || "Required",
      (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
    ],

    loggedin: false,
    show1: false,
    rules: {
      required: (value) => !!value || "Required.",
      min: (v) => (v && v.length >= 8) || "Min 8 characters",
    },
  }),
};
</script>

<style scoped></style>
